import React, { Component } from 'react';
import { Icon } from 'b3';
import './modal.less';
import { Motion, spring } from 'react-motion';
import KeyBinder from '../../utils/KeyBinder';

export default class Modal extends Component {
	state = {
		scale: 1,
		opacity: 1,
		closeOnRest: false
	};
	componentDidMount() {
        this.keyBinder = new KeyBinder({
            escapePressed: this.scheduleClose
        });
    }
    componentWillUnmount() {
        this.keyBinder.destroy();
    }
    scheduleClose = () => {
    	this.setState({
    		scale: 0.9,
    		opacity: 0,
    		closeOnRest: true
    	});
    }
    onRest = () => {
    	if(this.state.closeOnRest) {
    		this.props.onCancel();
    	}
    }
	render() {
		var { icon, children, title, hasCancel } = this.props;
		var { scale, opacity } = this.state;

		return (
			<Motion defaultStyle={{scale: 0.8, opacity: 0.4}} style={{scale: spring(scale), opacity: spring(opacity)}} onRest={this.onRest}>
			{({scale, opacity}) =>
				<div className="c3-modal" style={{opacity}}>
					<div className="content" style={{transform: `scale(${scale})`}}>
						{title &&
							<header>
								{ icon &&
								    <Icon icon={ icon } size={24} />
								}
								<h1>{title}</h1>

								{hasCancel &&
									<div className="close-x">
										<Icon onClick={this.scheduleClose} icon="cross" size={24} />
									</div>
								}
							</header>
						}
						{children}
					</div>	
				</div>
			}
			</Motion>
		);
	}
}



// WEBPACK FOOTER //
// ./app/c3/modal/Modal.js